module.exports = __webpack_public_path__ + "9516852fa0c2caf8e453737f2aa5dd45.svg";